import { render, staticRenderFns } from "./trial.vue?vue&type=template&id=076c4a54&scoped=true&"
import script from "./trial.vue?vue&type=script&lang=js&"
export * from "./trial.vue?vue&type=script&lang=js&"
import style0 from "./trial.vue?vue&type=style&index=0&id=076c4a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c4a54",
  null
  
)

export default component.exports